import React from 'react';
import ReactPaginate from 'react-paginate';
import { ChevronDown, ChevronsLeft, ChevronsRight } from 'react-feather';
import { default as ReactDataTable } from 'react-data-table-component';
import { Button, Input, Label } from 'reactstrap';
import './Datatable.css';
import LoadingSpinner from './LoadingSpinner';
import NoDataMessage from './NoDataMessage';

const firstAndLastStyle = {
	color: '#0DB944',
	backgroundColor: '#F3F8FF',
	padding: '5px',
	marginRight: '1rem'
};

const customStyles = {
	tableWrapper: {
		style: {
			display: 'table',
			height: '100%',
			minHeight: '350px'
		}
	},
	header: {
		style: {
			minHeight: '31px',
			paddingLeft: '16px',
			paddingRight: '8px'
		}
	},
	headRow: {
		style: {
			minHeight: '31px',
			borderBottomStyle: 'node'
		}
	},
	rows: {
		style: {
			'&:not(:last-of-type)': {
				borderBottomStyle: 'none',
				borderBottomWidth: '1px'
			}
		},
		stripedStyle: {
			backgroundColor: '#FCFDFF'
		}
	},
	cells: {
		style: {
			border: '1px solid #F4F4F4'
		}
	},
	noData: {
		style: {
			display: 'flex',
			alignItems: 'flex-start',
			justifyContent: 'center'
		}
	}
};
const Datatable = ({
	mockData,
	columns,
	datatableState,
	handlePerPage,
	handlePagination,
	handleSort,
	noDataMessage
}) => {
	// ** Custom Pagination
	const CustomPagination = () => {
		return (
			<div className="custom_pagination">
				<div className="d-flex align-items-center justify-content-around">
					<Label className="m-0 mx-1" for="sort-select">
						Mostrar
					</Label>
					<Input
						style={{ width: 'min-content' }}
						className="dataTable-select"
						type="select"
						id="sort-select"
						value={datatableState?.per_page}
						onChange={(e) => handlePerPage(e)}
					>
						<option value={10}>10</option>
						<option value={25}>25</option>
						<option value={50}>50</option>
						<option value={100}>100</option>
					</Input>
					<Label className="m-0 mx-1" for="sort-select">
						filas
					</Label>
				</div>
				<div className="d-flex align-items-center justify-content-around">
					<Label
						className="my-1 mx-1 font-small-2 font-weight-lighter font-italic"
						for="sort-select"
					>
						{`Mostrando del ${datatableState?.from || '-'} 
							al ${datatableState?.to || '-'} 
							de ${datatableState?.total || '-'} totales`}
					</Label>
				</div>
				<div className="d-flex align-items-center justify-content-around">
					<Button
						style={firstAndLastStyle}
						color={null}
						onClick={() => handlePagination({ selected: 0 })}
					>
						<ChevronsLeft size={18} />
					</Button>
					<ReactPaginate
						previousLabel={''}
						nextLabel={''}
						breakLabel="..."
						pageCount={datatableState?.last_page}
						marginPagesDisplayed={2}
						pageRangeDisplayed={2}
						activeClassName="active"
						forcePage={
							datatableState?.current_page !== 0
								? datatableState?.current_page - 1
								: 0
						}
						onPageChange={(page) => handlePagination(page)}
						pageClassName={'page-item'}
						nextLinkClassName={'page-link'}
						nextClassName={'page-item next'}
						previousClassName={'page-item prev'}
						previousLinkClassName={'page-link'}
						pageLinkClassName={'page-link'}
						breakClassName="page-item"
						breakLinkClassName="page-link"
						containerClassName={
							'pagination react-paginate separated-pagination pagination-sm justify-content-end pr-1 mt-1'
						}
					/>
					<Button
						style={firstAndLastStyle}
						color={null}
						onClick={() =>
							handlePagination({ selected: datatableState.last_page - 1 })
						}
					>
						<ChevronsRight size={18} />
					</Button>
				</div>
			</div>
		);
	};

	return (
		<>
			<div className="bg-white mb-0 datatable_container">
				<ReactDataTable
					noHeader
					pagination
					paginationServer
					className="react-dataTable border-light"
					progressPending={datatableState.isLoading}
					progressComponent={<LoadingSpinner />}
					noDataComponent={<NoDataMessage label={noDataMessage} />}
					columns={columns}
					sortIcon={<ChevronDown size={10} />}
					onSort={handleSort}
					sortServer
					paginationComponent={CustomPagination}
					data={mockData ? mockData : datatableState?.data}
					striped={true}
					customStyles={customStyles}
				/>
			</div>
		</>
	);
};

export default Datatable;
